import { lazy, Suspense } from 'react';
import type { MantineRichTextEditorProps } from './mantine-rich-text-editor';

// Lazy load MantineRichTextEditor to split `tip-tap` from the main bundle
const MantineRichTextEditor = lazy(() => import('./mantine-rich-text-editor'));

const MantineRichTextEditorLazy = (props: MantineRichTextEditorProps) => {
  return (
    <Suspense>
      <MantineRichTextEditor {...props} />
    </Suspense>
  );
};

MantineRichTextEditorLazy.displayName = 'MantineRichTextEditorLazy';

export { HeadingLevel } from './toolbar-controls';
export default MantineRichTextEditorLazy;
